import React from 'react';

const TableHeaderCell = ({
  children,
  colspan,
  className,
  ...extraProps
}: any) => {
  return (
    <th className={`uppercase ${className}`} colSpan={colspan} {...extraProps}>
      {children}
    </th>
  );
};

TableHeaderCell.defaultProps = {
  colspan: null,
  className: '',
};

export default TableHeaderCell;
